import React, { useState, useEffect } from 'react'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom'
import logo from '../../Assets/logo.svg'
import menu from '../../Assets/menu.svg'
import cross from '../../Assets/menuCross.svg'

import './NavBar.css'


const NavBar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleLinkClick = () => {
        setIsMenuOpen(false);
    };


    return (
        <nav className='navBar'>
            <Link to="/"><img src={logo} alt="NIDAAN" className='navLogo' /></Link>
            <div className={`navHiddenContainer ${isMenuOpen ? 'open' : ''}`}>
                <div className="navLinkConatiner">
                    <div className="navLink">
                        <Link to="/" onClick={handleLinkClick}>Home</Link>
                        <Link to="/meetneo" onClick={handleLinkClick}>Meet with Neo</Link>
                        <Link to="/pricing" onClick={handleLinkClick}>Pricing</Link>
                        <Link to="/blogs" onClick={handleLinkClick}>Blogs</Link>
                        <Link to="/contact" onClick={handleLinkClick}>Contact Us</Link>
                    </div>
                    <div className="registerSection">
                        <Link to='/signin'><button className='signInBtn' onClick={handleLinkClick}>Sign In</button></Link>
                        <Link to='/register'><button className='registerBtn' onClick={handleLinkClick}>Register Now</button></Link>
                    </div>
                </div>
            </div>
            <img src={menu} alt="" id='menuBtn' className={`menuBtn ${isMenuOpen ? '' : 'open'}`} onClick={toggleMenu} />
            <img src={cross} alt="" id='crossBtn' className={`crossBtn ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu} />
        </nav>
    )
}

export default NavBar;

